var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Actions/TrackClientEventAction',["require", "exports", "loglevel", "score_ccf/XPerience/XPActionBase", "score_ccf/Utils/global", "object-assign"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var log = require("loglevel");
    var XPActionBase_1 = require("score_ccf/XPerience/XPActionBase");
    var global_1 = require("score_ccf/Utils/global");
    var objectAssign = require("object-assign");
    var TrackClientEventAction = /** @class */ (function (_super) {
        __extends(TrackClientEventAction, _super);
        function TrackClientEventAction(attributes) {
            return _super.call(this, attributes) || this;
        }
        TrackClientEventAction.prototype.execute = function (component) {
            if (global_1.default['gtag'] && global_1.default['gtag'] instanceof Function) {
                var fieldsObj = {};
                if (this.eventCategory != null) {
                    fieldsObj['event_category'] = this.eventCategory;
                }
                if (this.eventLabel != null) {
                    fieldsObj['event_label'] = this.eventLabel;
                }
                if (this.eventValue != null) {
                    fieldsObj['value'] = this.eventValue;
                }
                if (this.dimensions != null) {
                    objectAssign.polyfill();
                    fieldsObj = Object.assign(fieldsObj, this.dimensions);
                }
                global_1.default['gtag'].apply(null, ['event', this.eventAction, fieldsObj]);
            }
            else {
                log.error("Cannot send GA event, because GA is not defined. Please include GA script to a page");
            }
        };
        return TrackClientEventAction;
    }(XPActionBase_1.XPActionBase));
    exports.default = TrackClientEventAction;
});
//# sourceMappingURL=TrackClientEventAction.js.map;
